import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TuiTextfieldControllerModule, TuiMultiSelectModule, TuiSelectModule } from '@taiga-ui/legacy';
import { TuiAvatar } from '@taiga-ui/kit';
import { TuiAutoColorPipe, TuiDataList, TuiFallbackSrcPipe, TuiHint, TuiInitialsPipe } from '@taiga-ui/core';
import { ComponentsModule } from '@src/app/components';
import { SharedModule } from '@src/app/shared';

import { OrganisationInputComponent, RenderOrganisationRowComponent } from './components';

@NgModule({
  declarations: [OrganisationInputComponent, RenderOrganisationRowComponent],
  imports: [
    CommonModule,
    ComponentsModule,
    FormsModule,
    TuiSelectModule,
    TuiTextfieldControllerModule,
    ...TuiDataList,
    TuiMultiSelectModule,
    TuiAvatar,
    SharedModule,
    ...TuiHint,
    TuiFallbackSrcPipe,
    TuiInitialsPipe,
    TuiAutoColorPipe,
  ],
  exports: [OrganisationInputComponent],
})
export class OrganisationInputModule {}
